"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const classnames_1 = require("classnames");
const formik_1 = require("formik");
const React = require("react");
const yup = require("yup");
const Input_1 = require("./Input");
const Textarea_1 = require("./Textarea");
function Item({ field, formProps, theme = {}, }) {
    if (field.type === 'textarea') {
        return (React.createElement(Textarea_1.default, { name: field.field, label: field.label, helpText: field.helpText, errorText: formProps.touched[field.field] &&
                formProps.errors[field.field], inputProps: {
                name: field.field,
                value: formProps.values[field.field],
                onChange: formProps.handleChange,
                onBlur: formProps.handleBlur,
            }, theme: theme }));
    }
    const errorText = formProps.touched[field.field] && formProps.errors[field.field];
    const successText = formProps.touched[field.field] &&
        !formProps.errors[field.field] &&
        field.successText;
    const helpText = !successText && field.helpText;
    return (React.createElement(Input_1.default, { name: field.field, label: field.label, helpText: helpText, errorText: errorText, successText: successText, inputProps: {
            name: field.field,
            type: field.type,
            value: formProps.values[field.field],
            onChange: formProps.handleChange,
            onBlur: formProps.handleBlur,
        }, theme: theme }));
}
function makeValidationSchema(fields) {
    const tmp = fields.reduce((acc, field) => {
        const { validateType, validators = [] } = field;
        if (!validateType) {
            return acc;
        }
        if (!yup[validateType]) {
            return acc;
        }
        let fieldValidator = yup[validateType]();
        validators.forEach(item => {
            if (!item.params) {
                return fieldValidator[item.name]();
            }
            if (item.name === 'matches') {
                const [regex, errorMessage] = item.params;
                fieldValidator = fieldValidator.matches(new RegExp(regex), errorMessage);
            }
            else {
                fieldValidator = fieldValidator[item.name](...item.params);
            }
        });
        return {
            ...acc,
            [field.field]: fieldValidator,
        };
    }, {});
    return yup.object().shape(tmp);
}
const Form = ({ form, overrideValues, subscribeEndpoint, onComplete, theme = {}, ...rest }) => (React.createElement(formik_1.Formik, { initialValues: form.defaultValues, validationSchema: makeValidationSchema(form.fields), onSubmit: (values, { setSubmitting /* setErrors, setValues and other goodies */ }) => {
        axios_1.default
            .post(subscribeEndpoint, {
            ...values,
            ...overrideValues,
            campaignCode: form.campaignCode,
        })
            .then(() => {
            setSubmitting(false);
            if (onComplete) {
                onComplete();
            }
        });
    }, render: formProps => {
        const { handleSubmit, isSubmitting } = formProps;
        return (React.createElement("form", Object.assign({ className: theme.root, onSubmit: handleSubmit }, rest),
            React.createElement("div", { className: theme.body }, form.fields.map(field => {
                return (React.createElement(Item, { key: field.field, field: field, formProps: formProps, theme: theme.formItem }));
            })),
            React.createElement("div", { className: theme.buttonWrapper },
                React.createElement("button", { className: classnames_1.default(theme.button, {
                        [theme.notSubmitting || '']: !isSubmitting,
                        [theme.submitting || '']: isSubmitting,
                    }), disabled: isSubmitting, type: "submit" },
                    !isSubmitting && form.submitText,
                    isSubmitting && form.submitingText))));
    } }));
exports.default = Form;
//# sourceMappingURL=index.js.map